export { TinyMceInline } from './tiny-mce-inline';
